document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-read-more-two]').forEach(function (el) {
        var toggleButton = el.querySelector('[data-toggle]');
        var isOpen = false;
        toggleButton.addEventListener('click', function() {
            if (isOpen) {
                el.classList.remove('read-more-two--visible');
                toggleButton.innerHTML = 'Read more';
                isOpen = false;
            } else {
                el.classList.add('read-more-two--visible');
                toggleButton.innerHTML = 'Read less';
                isOpen = true;
            }
        });
    });
});